// extracted by mini-css-extract-plugin
export default {"Main":"OptionSize_Main__7ErRq","Text":"OptionSize_Text__Veot8","As":"OptionSize_As__TmbVg","AsTarget":"OptionSize_AsTarget__oFZzV"};